<template>
  <div>
    <b-row>
      <b-col sm="1">
        <h3>Empleados</h3>
      </b-col>
    </b-row>
    <br>
    <div class="card border-0 bg-primary text-white">
      <div class="card-body">
        <div class="d-flex flex-wrap align-items-center">
          <i class="icmn-user-tie font-size-50 mr-3" />
          <div>
            <div class="font-size-21 font-weight-bold">Empleados contratados</div>
            <div class="font-size-15">Total: {{ totalEmployees }}</div>
          </div>
        </div>
      </div>
    </div>
    <b-row>
      <b-col>
        <h5 class="mb-4">
          <a-tooltip placement="top">
            <template slot="title">
              <span>Ver filtros</span>
            </template>
            <a-button class="ml-2" type="primary" @click="visibleCollapse = !visibleCollapse"  shape="circle" icon="search"/>
          </a-tooltip>
        </h5>
      </b-col>
      <b-col>
        <div class="text-right">
          <!-- <a-button>
            <a-icon type="upload" />Importar desde Excel
          </a-button>
          &nbsp; &nbsp; -->
          <router-link to="/employees/create" class="ant-btn">
            <a-icon type="plus" /> Nuevo Empleado
          </router-link>
        </div>
      </b-col>
    </b-row>
    <b-collapse id="collapse-1" class="mt-2" v-model="visibleCollapse">
      <b-form>
        <b-row align-v="center">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Identificación:" label-for="input-1">
              <b-form-input id="input-1" v-model="fields.cc" placeholder="Número de identificación"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-2" label="Salario:" label-for="input-2">
              <b-form-input id="input-2" v-model="fields.salary" placeholder="Salario"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-3" label="Nombre:" label-for="input-3">
              <b-form-input id="input-3" v-model="fields.fullName" placeholder="Nombre del empleado"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-4" label="Cargo:" label-for="input-4">
              <b-form-input id="input-4" v-model="fields.jobPosition" placeholder="Nombre del cargo"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2 align-items-center">
            <b-form-checkbox
              id="input-group-5"
              v-model="fields.isHired"
              name="checkbox-1"
            >
              Contratatado
            </b-form-checkbox>
          </div>
        </b-row>
      </b-form>
    </b-collapse>
    <b-row>
      <b-col>
        <b-table v-if="data.length > 0" id="table-periods-payrolls" :per-page="pagination.perPage" :current-page="pagination.currentPage" striped hover :fields="columns" :items="data" head-variant="light" responsive>
          <template #cell(actions)="employee">
            <a-tooltip placement="top">
              <template slot="title">
                <span>Ver información</span>
              </template>
              <button @click="showEmployeeInformation(employee.item.id)" type="button" class="btn btn-light mr-2">
                <i class="fa fa-eye" />
              </button>
            </a-tooltip>
            <a-tooltip placement="top">
              <template slot="title">
                <span>Editar información</span>
              </template>
              <router-link :to="{ name: 'edit-employee', params: { idEmployee: employee.item.id } }" class="btn btn-light mr-2">
                <i class="fa fa-pencil text-blue" />
              </router-link>
            </a-tooltip>
            <a-tooltip placement="top" v-if="employee.item.isActive">
              <template slot="title">
                <span>Finalizar contrato</span>
              </template>
              <button type="button" @click="() => openModalEndingContract(employee.item.id, false)" class="btn btn-light mr-2">
                <i class="fe fe-feather " />
              </button>
            </a-tooltip>
            <a-tooltip placement="top">
              <template slot="title">
                <span>Eliminar</span>
              </template>
              <button type="button" class="btn btn-light mr-2" @click="alertToDeleteEmployee(employee.item)">
                <i class="fa fa-trash text-danger" />
              </button>
            </a-tooltip>
          </template>
        </b-table>
        <empty-table v-else/>
      </b-col>
    </b-row>
    <!-- <br/> -->
    <b-row>
      <b-col>
        <b-pagination v-model="pagination.currentPage" :total-rows="pagination.rows" :per-page="pagination.perPage"
        aria-controls="table-periods-payrolls" @change="debounce()"></b-pagination>
      </b-col>
    </b-row>
    <b-modal id="ending-contract" ref="modal" title="Terminación de contrato" hide-footer size="md" @hidden="onHidden">
      <b-row class="justify-content-center my-3">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Placeholder_no_text.svg/1200px-Placeholder_no_text.svg.png"  width="175" alt="..." class="img-thumbnail img-fluid" style="display: block;">
      </b-row>
      <b-row class="mt-4 px-3">
        <b-col sm="12">
          <validation-provider
            name="Fecha de terminación"
            :rules="{ required: true }"
            v-slot="validationContext"
          >
            <b-form-group id="input-group-deactivationDate" label="Fecha de terminación:"
            label-for="input-deactivationDate" :invalid-feedback="validationContext.errors[0]">
              <b-form-datepicker
                id="input-deactivationDate"
                v-model="contractSelected.deactivationDate"
                type="date"
                placeholder="Seleecione una fecha"
                style="width: 100%"
                required
                :min="contractSelected.workStartDate" :max="contractSelected.workEndDate"
                locale="es"
                :state="getValidationState(validationContext)"
              ></b-form-datepicker>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col sm="12">
          <validation-provider
              name="Motivo de la terminación"
              :rules="{ required: true }"
              v-slot="validationContext"
            >
            <b-form-group id="input-group-causeOfWithdrawal" label="Motivo de la terminación:" label-for="input-causeOfWithdrawal"
              :invalid-feedback="validationContext.errors[0]">
              <b-form-select id="input-causeOfWithdrawal" v-model="contractSelected.causeOfWithdrawal" :options="withdrawalOptions" required
              :state="getValidationState(validationContext)"></b-form-select>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider
              name="Observaciones"
              :rules="{ required: false }"
              v-slot="validationContext"
            >
            <b-form-group id="input-group-observation" label="Observaciones:" label-for="input-observation"
              :invalid-feedback="validationContext.errors[0]">
              <b-form-textarea id="input-observation" v-model="contractSelected.observations" required autocomplete="shut-up-google"
              rows="3" max-rows="6" :state="getValidationState(validationContext)" placeholder=""></b-form-textarea>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col sm="12" align="middle">
          <b-button @click="terminateContract()" variant="primary" class="my-3">Finalizar</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <ModalEmployeeInformation :idEmployee="idEmployee"/>
  </div>
</template>
<script>
import apiClient2 from '@/services/axios/v2.js'
import { currencyFormatPesos } from '@/services/utilities'
import emptyTable from '@/components/custom/cardEmptyList'
import ModalEmployeeInformation from '@/components/custom/payroll/ModalEyeEmployee'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'employeesView',
  components: {
    emptyTable,
    ModalEmployeeInformation,
  },
  data() {
    return {
      data: [],
      idEmployee: null,
      totalEmployees: 0,
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      typingTimer: '',
      visibleCollapse: false,
      contractSelected: {
        deactivationDate: null,
        causeOfWithdrawal: null,
        observations: null,
        workStartDate: null,
        workEndDate: null,
      },
      fields: {
        cc: '',
        salary: '',
        fullName: '',
        jobPosition: '',
        isHired: true,
        page: 1,
      },
      isDeleting: false,
      withdrawalOptions: [
        { text: 'Seleccione una opción...', value: null },
        { text: 'Retiro voluntario', value: 'Retiro voluntario' },
        { text: 'Despido justificado', value: 'Despido justificado' },
        { text: 'Despido injustificado', value: 'Despido injustificado' },
      ],
      columns: [
        {
          label: 'Nombre',
          key: 'name',
        },
        {
          label: 'Cargo',
          key: 'workPosition',
        },
        {
          label: 'Identificación',
          key: 'nip',
        },
        {
          label: 'Salario',
          key: 'salary',
        },
        {
          label: 'Acciones',
          key: 'actions',
        },
      ],
      pagination: {
        rows: 0,
        perPage: 6,
        currentPage: 1,
      },
    }
  },
  created() {
    this.searchEmployees()
  },
  watch: {
    // Campos de busqueda
    'fields.cc': function () {
      this.debounce()
    },
    'fields.salary': function () {
      this.debounce()
    },
    'fields.fullName': function () {
      this.debounce()
    },
    'fields.jobPosition': function () {
      this.debounce()
    },
    'fields.isHired': function () {
      this.debounce()
    },
  },
  methods: {
    // Se usa para verificar si un empleado se encuentra activo
    checkIfActive(contracts) {
      for (const contract of contracts) {
        return (contract.deactivationDate)
      }
      return false
    },
    // Abre el modal para la finalización del contrato
    openModalEndingContract(idEmployee, isDeleting) {
      return new Promise((resolve, reject) => {
        apiClient2.get('employees/' + idEmployee + '/contracts?activeContract=true').then((response) => {
          this.contractSelected = response.data.data[0]
        }).catch((error) => {
          reject(error)
        })
        this.$bvModal.show('ending-contract')
        this.isDeleting = isDeleting
        resolve()
      })
    },
    // Muestra la información del empleado
    showEmployeeInformation(idEmployee) {
      this.idEmployee = idEmployee
      this.$bvModal.show('modal-view-employee')
    },
    // Acción cuando se oculta el modal
    onHidden() {
      const keys = Object.keys(this.contractSelected)
      for (const key of keys) {
        this.contractSelected[key] = null
      }
      this.isDeleting = false
    },
    // Validation state(vee-validate)
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    // Finalización del contrato
    terminateContract() {
      apiClient2.patch('employees/' + this.contractSelected.idEmployee + '/contracts/' + this.contractSelected.id, this.contractSelected).then((res) => {
        Toast.fire({
          icon: 'success',
          title: res.data.message,
        })
      })
      if (this.isDeleting) {
        this.deleteEmployee(this.contractSelected.idEmployee)
      }
      // Cargamos la lista de empleados
      this.searchEmployees()
      this.$bvModal.hide('ending-contract')
    },
    // Función para esperar unos segundos antes de realizar la busqueda
    debounce() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.searchEmployees() }, 500)
    },
    // Busca empleados dependiendo de los parametros seleccionados
    searchEmployees() {
      const query = {}
      const keys = Object.keys(this.fields)
      // Guardamos las propiedades para hacer un recorrido de los parametros
      for (const key of keys) {
        if (this.fields[key] !== '' && this.fields[key] !== 'false') {
          query[key] = this.fields[key]
        }
      }
      apiClient2.get('employees', { params: query }).then((response) => {
        const data = response.data.data
        this.totalEmployees = 0
        // Si la respuesta del servidor fue exitosa
        if (response.data.success) {
          this.data = data.employees.map((employee, i) => {
            const workData = {
              workPosition: '',
              salary: 0,
              date: null,
              isActive: true,
            }
            // Si tiene contratos activos recorremos cada contrato
            if (employee.contracts.length > 0) {
              for (const contract of employee.contracts) {
                // Si el contrato esta activo, se guarda en la variable y termina con el ciclo
                if (!contract.deactivationDate) {
                  this.totalEmployees += 1
                  workData.jobPosition = contract.jobPosition
                  workData.salary = contract.salary
                  workData.date = contract.createdAt
                  workData.isActive = true
                  break
                } else {
                  // Si no, verifica cada contrato hasta dejar el mas reciente para visualizar/editar
                  if (!workData.createdAt || contract.createdAt > workData.createdAt) {
                    workData.jobPosition = contract.jobPosition
                    workData.salary = contract.salary
                    workData.date = contract.createdAt
                    workData.isActive = false
                  }
                }
              }
            }
            // Aplicamos formato para el b-table
            return {
              key: i + 1,
              id: employee.id,
              name: employee.user.fullName,
              nip: employee.user.cc,
              workPosition: workData.jobPosition.toUpperCase(),
              salary: currencyFormatPesos(Number(workData.salary)),
              isActive: workData.isActive,
            }
          })
          this.pagination.rows = this.data.length
        } else {
          alert('Hubo un error en el servidor al traer los empleados!')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // Eliminación del empleado
    alertToDeleteEmployee(employee) {
      const message = employee.isActive ? `¿Estás seguro de eliminar el empleado con contrato activo <b>${employee.name}</b>?` : `¿Estás seguro de eliminar el empleado <b>${employee.name}</b>?`
      Swal.fire({
        title: 'Confirmar eliminación',
        html: `
            <div>
              <p style="margin  :0">${message}</p>
            </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (employee.isActive) {
            this.openModalEndingContract(employee.id, true)
          } else {
            this.deleteEmployee(employee.id)
          }
        }
      }).catch((error) => {
        Toast.fire({
          icon: 'warning',
          title: `Error: ${error.error.message}`,
        })
      })
    },
    // Eliminación del empleado
    deleteEmployee(employee) {
      apiClient2.delete(`employees/${employee}`).then((response) => {
        Toast.fire({
          icon: 'success',
          title: 'Empleado eliminado con éxito',
        })
        this.searchEmployees()
        this.isDeleting = false
      })
    },
  },
}
</script>
<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
